import { useEffect, useState } from "react"
import { useRouter } from "next/router"
import { checkAuth } from "../utils/auth"

export const useRequireAuth = (redirectUrl = "/sign-in") => {
  const router = useRouter()
  const [authenticated, setAuthenticated] = useState(false)

  useEffect(() => {
    const redirectUnauthenticated = async () => {
      const authenticated = await checkAuth()
      if (!authenticated) {
        router.push(
          `${redirectUrl}?redirect=${encodeURIComponent(router.asPath)}`
        )
      } else {
        setAuthenticated(true)
      }
    }

    redirectUnauthenticated()
  }, [router, redirectUrl])

  return authenticated
}

export const useCheckAuth = () => {
  const router = useRouter()
  const [authenticated, setAuthenticated] = useState(false)
  const [loadingAuth, setLoadingAuth] = useState(true)

  useEffect(() => {
    const checkAuthentication = async () => {
      const authenticated = await checkAuth()
      if (authenticated) {
        setAuthenticated(true)
      }

      setLoadingAuth(false)
    }

    checkAuthentication()
  }, [router])

  return { authenticated, loadingAuth }
}
